import MovementRecordTypeService from "@/services-http/sdi/MovementRecordTypeService";
import BenefitService from "@/services-http/odoo/BenefitService";
import KinshipService from "@/services-http/contract/KinshipService";
import ContractBenefitService from "@/services-http/contract/ContractBenefitService"
import { mapMutations } from "vuex";
import BeneficiaryContractedPlanService from "@/services-http/contract/BeneficiaryContractedPlanService";
import DependentContractedPlanService from "@/services-http/contract/DependentContractedPlanService";
import MovementRecordService from "@/services-http/sdi/MovementRecordService";
import MovementDeadlineMixin from '@/shared/mixins/movementRecords/movementDeadlineMixin';
import moment from 'moment';
import {
  insertBackofficeDependentPaddingHeaders,
  insertBackofficeHeadersBeforeStatus,
  resolveResponsibleUserDisplay,
  resolveStructureNameDisplay,
} from '@/shared/utils/movement-attendance-display';

export default {
  mixins: [
    MovementDeadlineMixin,
  ],

  data: () => ({
    movementTypeService: null,
    benefitService: null,
    kinshipService: null,
    contractBenefitService: null,
    movService: null,
    movementTypes: [],
    benefitTypes: [],
    filterFileMovements: {
      onlyFtpIntegration: false,
      protocolNumber: '',
      createdBy: '',
      financialGroup: '',
      receivingDateStart: '',
      receivingDateEnd: '',
      status: '',
      withErrors:'',
      helpdeskId: '',
      responsibleUserIds: [],
      structureIds: [],
      includeUnassignedResponsible: true,
    },
    filterShippingBatches: {
      id: '',
      insuranceCarrierId: [],
      createdAtStart: '',
      createdAtEnd: '',
      sendAtStart: '',
      sendAtEnd: '',
      protocolNumber: '',
      status: '',
      createdBy: '',
      batchType: '',
      movementInsuranceCarrierId: '',
      onlyManualProtocol: false,
      financialGroupIds: [],
    },
    filterMovements: {
      protocolNumber: '',
      movementRecordId: '',
      movementInsuranceCarrierId: '',
      fileDataId: '',
      financialGroup: '',
      contractId: '',
      subContractId: '',
      name: '',
      document: '',
      nameDependent: '',
      documentDependent: '',
      movementType: [],
      status: [],
      dateType: 'isMovementDate',
      receivingDateStart: '',
      receivingDateEnd: '',
      insuranceCarrierIds: [],
      onlyManualProtocol: false,
      onlyErrors: false,
      appOrigin: 'allChannels',
      pendingMovements: false,
      internalCriticism: 'both',
      withDependents: false,
      helpdeskId: '',
      responsibleUserIds: [],
      structureIds: [],
      includeUnassignedResponsible: true,
    },
    filterMyReports: {
      financialGroupId: '',
      reportLayout: '',
      status: '',
      receivingDateStart: '',
      receivingDateEnd: '',
    },
    loadingBenefits: false,
    momentMixin: moment,
  }),

  methods: {
    ...mapMutations({
      setMovementTypes: "movement-type/setMovementTypes",
    }),

    async loadMovementTypes() {
      await this.movementTypeService.FindAll().then((response) => {
        this.movementTypes = response.data.sort((a, b) => (a.description > b.description ? 1 : -1));
        this.movementTypes = this.movementTypes.map(
          (movementType) => {
            movementType.name = movementType.name.charAt(0).toUpperCase() + movementType.name.slice(1).toLowerCase();

            return movementType;
          })

        this.setMovementTypes(this.movementTypes);
      });
    },

    async loadBenefitTypes() {
      await this.benefitService.FindAll().then((response) => {
        if (response && response.data && response.data.records.length) {
          this.benefitTypes = response.data.records.filter((benefit) => benefit.xipp_contract_record_type_code !== null);
        }
      });
    },

    formatBenefitType(benefitType) {
      let benefitName = '-';

      if (this.benefitTypes && this.benefitTypes.length > 0) {
        const benefitFound = this.benefitTypes.find((benefit) =>
          benefit.xipp_contract_record_type_code === benefitType || benefit.benefitTypeCode === benefitType);

        benefitName = benefitFound && benefitFound.name ? benefitFound.name : '-';
      }

      return benefitName;
    },

    insertBackofficeHeadersBeforeStatus(headers) {
      return insertBackofficeHeadersBeforeStatus(headers, this.isRHProtegido);
    },

    insertBackofficeDependentPaddingHeaders(headersDependents) {
      return insertBackofficeDependentPaddingHeaders(headersDependents, this.isRHProtegido);
    },

    resolveResponsibleUserDisplay(item) {
      return resolveResponsibleUserDisplay(item, this.formatter);
    },

    resolveStructureNameDisplay(item) {
      return resolveStructureNameDisplay(item);
    },

    benefitData(item, fields = {}) {
      const {
        policyField = 'policy',
        subContractField = 'subContract',
        benefitTypeField = 'benefitType',
      } = fields;
      const policy = item ? item[policyField] : null;
      const subContract = item ? item[subContractField] : null;
      const benefitType = item ? item[benefitTypeField] : null;
      const formattedBenefitType = benefitType ? `${this.formatBenefitType(benefitType)}` : '';
      const normalizedPolicy = policy !== null && policy !== undefined && policy !== '' ? `${policy}` : '';
      const normalizedSubContract = subContract !== null && subContract !== undefined && subContract !== '' ? `${subContract}` : '';
      let policyAndSubContract = '';

      if (normalizedPolicy && normalizedSubContract) {
        policyAndSubContract = `${normalizedPolicy}/${normalizedSubContract}`;
      } else if (normalizedPolicy) {
        policyAndSubContract = normalizedPolicy;
      } else if (normalizedSubContract) {
        policyAndSubContract = normalizedSubContract;
      }

      if (formattedBenefitType && policyAndSubContract) {
        return `${formattedBenefitType} - ${policyAndSubContract}`;
      }

      return formattedBenefitType || policyAndSubContract || '-';
    },

    async loadBenefitsByCarrierId(carrierId) {
      this.loadingBenefits = true;

      await this.contractBenefitService.FindBenefitsByCarrierId(carrierId)
        .then((response) => response.data)
        .then((result) => {
          const benefitTypes = result.map((benefit) => (
            { id: benefit.id, name: benefit.name, benefitTypeCode: benefit.benefitTypeCode.toUpperCase()}
          ));
          this.benefitTypes = benefitTypes;
        })
        .finally(() => this.loadingBenefits = false);
    },

    async loadBenefitsByContractId(contractId) {
      this.loadingBenefits = true;

      await this.contractBenefitService.FindBenefitsByContractId(contractId)
        .then((response) => response.data)
        .then((result) => {
          const benefitTypes = result.map((benefit) => (
            { id: benefit.id, name: benefit.name, benefitTypeCode: benefit.benefitTypeCode.toUpperCase()}
          ));
          this.benefitTypes = benefitTypes;
        })
        .finally(() => this.loadingBenefits = false);
    },

    async loadKinships() {
      await this.kinshipService.FindAll().then((response) => {
        if (response && response.data) {
          this.kinships = response.data;
          this.kinships.sort((a, b) => (a.description > b.description ? 1 : -1));
        }
      });
    },

    getMovementTypeDescription(movementType) {
      if (this.movementTypes.length === 0) return '';

      const movementTypeIndex = this.movementTypes.findIndex((el) => el.code === movementType);

      return this.movementTypes[movementTypeIndex].description;
    },

    async getHolderByMovementRecord(movementRecord) {
      const bcpService = new BeneficiaryContractedPlanService();

      const params = new URLSearchParams();
      params.append('cpf', movementRecord.holderDocumentNumber);
      params.append('contractIds', movementRecord.contractId);

      const result = await bcpService.HolderToCreateMovement(params)
        .then((response) => response.data)
        .then((result) => result.content[0]);

      return result;
    },

    async getHolderContractedPlanIdByMovementRecord(movementRecord) {
      const beneficiary = await this.getHolderByMovementRecord(movementRecord);

      return beneficiary.contractPlanId;
    },

    async getDependentByMovementRecord(movementRecord) {
      const dcpService = new DependentContractedPlanService()

      const params = new URLSearchParams();
      params.append('cpf', movementRecord.insuredDocumentNumber);
      params.append('contractIds', movementRecord.contractId);

      const result = await dcpService.DependentToCreateMovement(params)
        .then((response) => response.data)
        .then((result) => result.content[0]);

      return result;
    },

    async getDependentContractedPlanIdByMovementRecord(movementRecord) {
      const beneficiary = await this.getDependentByMovementRecord(movementRecord);

      return beneficiary.contractPlanId;
    },

    async getCalculateScheduledDate(validityDate, contractId, movementType) {
      const parsedValidityDate = moment.isMoment(validityDate)
        ? validityDate.clone()
        : moment(validityDate, ['DD/MM/YYYY', 'YYYY-MM-DD'], true);

      if (!parsedValidityDate.isValid()) return false;

      return await this.movService.CalculateScheduledDate(
        parsedValidityDate.format('YYYY-MM-DD'),
        contractId,
        movementType,
      )
        .then((response) => response.data)
        .then((result) => {
          if (typeof result !== 'string') return false;
          const scheduledDate =  result;
          const scheduledDateFormatted = moment(scheduledDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
          return scheduledDateFormatted;
        });
    },
  },

  created() {
    this.movementTypeService = new MovementRecordTypeService();
    this.contractBenefitService = new ContractBenefitService();
    this.benefitService = new BenefitService();
    this.kinshipService = new KinshipService();
    this.movService = new MovementRecordService();
  },
};
